import { Component, SimpleChanges, Input, Output, EventEmitter } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';

@Component({
  selector: 'ingresos',
  templateUrl: 'ingresos.html'
})
export class IngresosComponent {
  @Input() backButton: boolean = false;
  @Input() data: any;
  @Output() dataReturn: EventEmitter<any> = new EventEmitter<any>();
  @Output() otherInvestments: EventEmitter<any> = new EventEmitter<any>();
  @Output() formBack: EventEmitter<void> = new EventEmitter<void>();

  @Input() supuestos1 = {
    nombre: '',
    edadJubilacion: 0,
    edadIngreso: 0,
    edadActual: 0,
    antiguedad: 0,
    miEsperanzaDeVida: 0,
    esperanzaDeVidaGeneral: 0,
    semanasCotizadas: 0,
    anosCotiz: 0,
    anoImss: 1995,
    regimenJubilatorioImss: 1973,
    sueldoMensual: 0,
    sueldoIntegrado: 0,
    sueldoDiario: 0,
    factorInteg: 0,
    ingresoNeto: 0,
    planJubilacion: false,
    planEquivaleEnIL: 0,
    ahorrasParaJubilarte: false,
    ahorroIndividual: 0,
    saldoInicial: 0,
    anosAhorrando: 0,
    otrasInversiones: 0
  }
  @Input() pensiones = {
    imms: {
      val: 0,
      type: 0
    },
    empresa: 0,
    miAhorro: 0,
    inversiones: 0,
    adicional: 0,
    sueldo: 0
  }
  @Input() pensionesJubilacionSubTotal: number = 0;
  @Input() pensionesJubilacionTotal: number = 0;

  @Input() chartLabels: string[] = [''];
  @Input() chartData: number[] = [0];

  total: number = 0;
  myForm: FormGroup;

  public doughnutChartType: string = 'doughnut';
  public dougnutChartcolors: Array<any> = [
    {
      backgroundColor: ['#007AA9', '#463685', '#59D7B5', '#f53d3d']
    }
  ];

  public doughnutChartDataopts = {
    legend: { display: false }
  }
  constructor(public formBuilder: FormBuilder) {
    this.myForm = formBuilder.group({
      inversion1: [0, [Validators.required, Validators.min(0)]],
      inversion2: [0, [Validators.required, Validators.min(0)]],
      rentas: [0, [Validators.required, Validators.min(0)]],
      negocio: [0, [Validators.required, Validators.min(0)]]
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    this.supuestos1 = changes && changes.supuestos1 && changes.supuestos1.currentValue ? changes.supuestos1.currentValue : this.supuestos1;
    this.pensiones = changes && changes.pensiones && changes.pensiones.currentValue ? changes.pensiones.currentValue : this.pensiones;
    this.pensionesJubilacionSubTotal = changes && changes.pensionesJubilacionSubTotal && changes.pensionesJubilacionSubTotal.currentValue ? changes.pensionesJubilacionSubTotal.currentValue : this.pensionesJubilacionSubTotal;
    this.pensionesJubilacionTotal = changes && changes.pensionesJubilacionTotal && changes.pensionesJubilacionTotal.currentValue ? changes.pensionesJubilacionTotal.currentValue : this.pensionesJubilacionTotal;
    this.chartData = changes && changes.chartData && changes.chartData.currentValue ? changes.chartData.currentValue.map(element => { return Math.round(element); }) : this.chartData;
    this.chartLabels = changes && changes.chartLabels && changes.chartLabels.currentValue ? changes.chartLabels.currentValue : this.chartLabels;
    this._total();
  }

  ngOnInit() {
    if (this.data) {
      this.myForm.setValue(this.data);
    }
  }

  _total() {
    let obj = { inversiones: Number(this.myForm.value.inversion1) + Number(this.myForm.value.inversion2), otras: Number(this.myForm.value.rentas) + Number(this.myForm.value.negocio) }

    this.otherInvestments.emit(obj);
  }

  change1() {
    this._total();
  }

  change2() {
    this._total();
  }

  change3() {
    this._total();
  }

  change4() {
    this._total();
  }

  submit() {
    this.dataReturn.emit(this.myForm.value);
  }

  back(): void {
    this.formBack.emit();
  }

}


// WEBPACK FOOTER //
// ./src/components/retirement-tools/retirement-calculator/ingresos/ingresos.ts